import { CaseFormType, getLateralityPatch } from '@features/forms/CaseForms/schema';
import { getChangedValues, replaceEmptyWithNull } from '@/utils/helpers';
import { CustomLocation } from '@/api/apis/case';

export const locationChanged = (prevLocation?: CustomLocation | null, nexLocation?: CustomLocation | null) => {
  return nexLocation?.addressId && nexLocation?.addressId !== prevLocation?.addressId;
};

export const getCaseValuesToPatch = (prevFormData: Partial<CaseFormType>, nextFormData: Partial<CaseFormType>) => {
  const { files, links, hospitalCustomLocation, txCenterCustomLocation, laterality, ...valuesToPatch } = nextFormData;
  const changedValues = getChangedValues<Partial<CaseFormType>>(valuesToPatch, prevFormData);
  if (locationChanged(prevFormData?.hospitalCustomLocation, hospitalCustomLocation)) {
    changedValues.hospitalCustomLocation = hospitalCustomLocation;
  }
  if (locationChanged(prevFormData?.txCenterCustomLocation, txCenterCustomLocation)) {
    changedValues.txCenterCustomLocation = txCenterCustomLocation;
  }

  return replaceEmptyWithNull({
    ...changedValues,
    ...getLateralityPatch(nextFormData.organType, laterality),
  });
};
